<template>
    <el-dialog :title="titleLabel[dialogStatus]" :visible.sync="dialogVisible" class="mx-50" top="40px">
      <table width=100%>
        <tr>
          <th width=20%>账单金额</th>
          <th width=20% >已开票金额</th>
          <!-- <th width=20% >未确认金额</th> -->
          <th width=20%>正在开票金额</th>
          <th width=20%>未开票金额</th>
          <!-- <th width=25% >不开票金额</th> -->
          <th></th>
        </tr>
        <tr>
          <td>
            总共：{{ receivable_amount }} 元<br/>
            <!-- 专票：{{ receivable_special_amount }} 元<br/>
            普票：{{ receivable_ordinary_amount }} 元<br/>
            收据：{{ no_invoice }} 元<br/> -->
          </td>
          <td>
            总共：{{ modify_confirmed_amount + no_invoice }} 元<br/>
            专票：{{ modify_confirmed_special_amount }} 元<br/>
            普票：{{ modify_confirmed_ordinary_amount }} 元<br/>
            收据：{{ no_invoice }} 元
          </td>
          <!-- <td>
            总共：{{ modify_unconfirmed_amount }} 元<br/>
            专票：{{ modify_unconfirmed_special_amount }} 元<br/>
            普票：{{ modify_unconfirmed_ordinary_amount }} 元
          </td> -->
          <td>
            总共：{{ modify_application_amount }} 元<br/>
            专票：{{ modify_application_special_amount }} 元<br/>
            普票：{{ modify_application_ordinary_amount }} 元
          </td>
          <td>
            总共：{{ modify_unapplication_amount }} 元<br/>
            专票：{{ modify_unapplication_special_amount }} 元<br/>
            普票：{{ modify_unapplication_ordinary_amount }} 元
          </td>
          <!-- <td>{{no_invoice}}</td> -->
          
        </tr>
      </table>
      <el-divider></el-divider>
  
      <el-form :rules="rules" ref="dataForm" :model="formData" label-position="left" label-width="150px" class="mx-30">
        <el-form-item prop="invoice_type" label="发票类型">
          <el-radio-group v-model="formData.invoice_type" @change="ChangeInvoiceType">
            <el-radio :label=0 :disabled="isEdit">专票</el-radio>
            <el-radio :label=1 :disabled="isEdit">普票</el-radio>
          </el-radio-group>
          <!-- <el-radio v-model="formData.invoice_type" :label=0 :disabled="isEdit">专票</el-radio>
          <el-radio v-model="formData.invoice_type" :label=1 :disabled="isEdit">普票</el-radio> -->
        </el-form-item>
        <el-form-item prop="invoice_maker" label="开票方">
          <el-input v-model="invoice_maker" autoComplete="on"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="name" label="业务单位明细">
          <el-input v-model="formData.name" autoComplete="on" :disabled="isEdit"></el-input>
        </el-form-item> -->
        <el-form-item prop="name" label="业务单位明细">
        <el-select v-model="formData.name" placeholder="请选择抬头" clearable value-key="id" @change="handleSearchInvoiceTitle">
                    <el-option v-for="at in invoice_title_list" :key="at.id" :label="at.invoice_name"
                        :value="at"></el-option>
                  </el-select>
        </el-form-item>
        <el-form-item  label="业务单位类型">
          <el-input v-model="formData.type_name" autoComplete="on" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item  label="统一社会信用代码">
          <el-input v-model="formData.number" autoComplete="on" :disabled="isEdit" ></el-input>
        </el-form-item>

        <el-form-item  label="开户银行名" >
          <el-input v-model="formData.invoice_blank_name" autoComplete="on" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item  label="开户账号">
          <el-input v-model="formData.invoice_account" autoComplete="on" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item  label="注册场所地址">
          <el-input v-model="formData.invoice_address" autoComplete="on" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item  label="注册固定电话">
          <el-input v-model="formData.invoice_mobile" autoComplete="on" :disabled="isEdit"></el-input>
        </el-form-item>

        <el-form-item prop="invoiced_amount" label="开票金额">
          <el-input v-model="formData.invoiced_amount" autoComplete="on" ></el-input>
        </el-form-item>
        <el-form-item prop="vat" label="税价">
          <el-input v-model="vat" autoComplete="on" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item prop="sales" label="销售额" >
          <el-input v-model="sales" autoComplete="on" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item prop="invoice_number" label="发票号" v-if="dialogStatus !='action.update'">
          <el-input type="number" v-model="formData.invoice_number" autoComplete="on"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="taxpayer_id" label="纳税人识别号" v-if="dialogStatus !='action.update'">
          <el-input v-model="formData.taxpayer_id" autoComplete="on" disabled></el-input>
        </el-form-item> -->
        <el-form-item prop="invoiced_date" label="开票日期" v-if="dialogStatus !='action.update'">
          <el-date-picker
            v-model="formData.invoiced_date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="source_document" label="发票" v-if="dialogStatus !='action.update'">
          <el-upload
            :data="formData"
            ref="upload"
            :headers="headers"
            action=""
            :file-list="source_document_list"
            list-type="picture"
            :limit="1"
            :on-remove="handleRemoveSourceDocument"
            :on-preview="handlePreviewSourceDocument"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :http-request="handleSubmitWithSourceDocument"
            :auto-upload="false"
          >
            <template v-if="showDialogSave">
            <el-button slot="trigger" size="small" type="success" >选择发票</el-button>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="formData.remark" autoComplete="on" type="textarea" :autosize="{minRows: 4, maxRows: 6}"></el-input>
        </el-form-item>
        <el-form-item prop="invoice_remark" label="发票备注">
          <el-input v-model="formData.invoice_remark" autoComplete="on" type="textarea" :autosize="{minRows: 4, maxRows: 6}" maxlength="115" show-word-limit></el-input>
        </el-form-item>
  
        <el-form-item>
          <span style="float: right">
            <template v-if="showDialogSave">
            <el-button size="small" @click="cancelData">取消</el-button>
            <el-button v-if="dialogStatus=='action.check'"
                       type="primary" size="small"
                       @click="saveData(true)">同意</el-button>
            <el-button v-if="dialogStatus=='action.update'"
                       type="primary" size="small"
                       @click="updateData">确认修改</el-button>
            </template>
          </span>
        </el-form-item>
      </el-form>
      <el-form :rules="rules2" ref="dataForm2" :model="formData2" label-position="left" label-width="150px" class="mx-30"  v-if="dialogStatus=='action.check'">
        <el-form-item prop="refuse_reason" label="拒绝理由">
            <el-input v-model="formData2.refuse_reason" autoComplete="on" type="textarea" :autosize="{minRows: 4, maxRows: 6}"></el-input>
        </el-form-item>
        <el-form-item>
            <span style="float: right">
                <template v-if="showDialogSave">
                    <el-button v-if="dialogStatus=='action.check'"
                       type="warning" size="small"
                       @click="saveData(false)">拒绝</el-button>
                </template>
            </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </template>
  
  <script>
    import { fetchInsuranceFinanceReceivable, createInsuranceFinanceReceivable, updateInsuranceFinanceReceivable } from '@/api/group-insurance'
    import { fetchSourceDocumentList, deleteSourceDocument} from '@/api/group-insurance'
    import { fetchInsuranceFinanceReceivableApplication, checkInsuranceFinanceReceivableApplication, updateInsuranceFinanceApplicationReceivable} from '@/api/group-insurance'
    import { getToken } from '@/utils/auth'
    import { EventBus } from "@/utils/event-bus"
    import { formatDate, formatDateTime } from '@/utils/misc'
    import { validateInvoiceNumber } from '@/utils/validate'
  
    export default {
      name: 'receivable-application-dialog',
      filters: {
        formatDate
      },
      props: [
        'receivable_amount',
        'receivable_special_amount',
        'receivable_ordinary_amount',
        'confirmed_amount',
        'confirmed_special_amount',
        'confirmed_ordinary_amount',
        'unconfirmed_amount',
        'unconfirmed_special_amount',
        'unconfirmed_ordinary_amount',
        'application_amount',
        'application_special_amount',
        'application_ordinary_amount',
        'unapplication_amount',
        'unapplication_special_amount',
        'unapplication_ordinary_amount',
        'no_invoice',
      ],
      data() {
        var validateAmount = (rule, value, callback) => {
          if(
            this.modify_unconfirmed_ordinary_amount < 0.0 ||
            this.modify_unconfirmed_special_amount < 0.0 ||
            this.modify_unapplication_ordinary_amount < 0.0 ||
            this.modify_unapplication_special_amount < 0.0
          ) {
            return callback(new Error('未确认金额或未申请金额小于0'))
          } else {
            return callback()
          }
        };
        return {
          dialogStatus: null,
          dialogVisible: false,
          showDialogSave: true,
          invoice_title_list:[],
          isEdit:false,
          select_amount:0,
          update_form:{},
          invoice_maker:'广东中小船东互助发展中心',
          is_superuser: undefined,
          titleLabel: {
            'action.check': '审核收入',
            'action.update': '修改申请',
          },
          formData: {
            invoice_maker: '',
            name: '',
            account_sum:0,
            taxpayer_id: '91440101MA5APK8L9P',
            invoice_number: '',
            invoiced_amount: 0,
            invoiced_date: null,
            vat: 0,
            sales: 0,
            finance: null,
            remark: '',
            invoice_remark: '',
            invoice_type:null,
            refuse_reason: '',
          },
          formData2: {
            refuse_reason: '',
          },
          isDisabled: false,
          initAmount: 0.0,
          initInvoiceType: null,
          source_document_list:[],
          rules: {
            invoice_type: [
              {required: true, message:'请选择发票类型' ,trigger: 'blur'},
            ],
            name: [
              {required: true, message:'请填写业务单位明细' ,trigger: 'blur'},
            ],
            invoiced_amount: [
              {required: true, message:'请输入开票金额' ,trigger: 'blur'},
              {validator: validateAmount, trigger: 'blur'}
            ],
            invoiced_date: [
              {required: true, message:'请选择到账日期' ,trigger: 'blur'},
            ],
            invoice_number: [
              {required: true, trigger: 'blur', validator: validateInvoiceNumber},
            ],
            // taxpayer_id: [
            //   {required: true, message:'请输入纳税人识别号' ,trigger: 'blur'},
            // ],
          },
          rules2: {
            refuse_reason: [
              {trigger: 'blur', required: true, message: '请填写拒绝原因'},
            ],
          }
        }
      },
      computed: {
        modify_confirmed_amount: function(){
          let result = 0.0
          result = this.modify_confirmed_special_amount + this.modify_confirmed_ordinary_amount
          return parseFloat(result.toFixed(4))
        },
        modify_confirmed_special_amount: function(){
          if (this.formData.invoice_type === null ||
          this.formData.invoice_type === undefined ||
          this.formData.invoice_type === '' ||
          this.formData.invoiced_amount === null ||
          this.formData.invoiced_amount === undefined ||
          this.formData.invoiced_amount === '' ||
          this.dialogStatus === 'action.update') {
            return this.confirmed_special_amount
          }
          let result = 0.0
          if (this.formData.invoice_type === 0) {
            result = this.confirmed_special_amount + parseFloat(this.formData.invoiced_amount)
          } else {
            return this.confirmed_special_amount
          }
          return parseFloat(result.toFixed(4))
        },
        modify_confirmed_ordinary_amount: function(){
          if (this.formData.invoice_type === null ||
          this.formData.invoice_type === undefined ||
          this.formData.invoice_type === '' ||
          this.formData.invoiced_amount === null ||
          this.formData.invoiced_amount === undefined ||
          this.formData.invoiced_amount === '' ||
          this.dialogStatus === 'action.update') {
            return this.confirmed_ordinary_amount
          }
          let result = 0.0
          if (this.formData.invoice_type === 1) {
            result = this.confirmed_ordinary_amount + parseFloat(this.formData.invoiced_amount)
          } else {
            return this.confirmed_ordinary_amount
          }
          return parseFloat(result.toFixed(4))
        },
        modify_application_amount: function(){
          let result = 0.0
          result = this.modify_application_special_amount + this.modify_application_ordinary_amount
          return parseFloat(result.toFixed(4))
        },
        modify_application_special_amount: function(){
          if (this.formData.invoice_type === null ||
          this.formData.invoice_type === undefined ||
          this.formData.invoice_type === '' ||
          this.formData.invoiced_amount === null ||
          this.formData.invoiced_amount === undefined ||
          this.formData.invoiced_amount === '') {
            return this.application_special_amount
          }
          let result = 0.0
          if (this.dialogStatus === 'action.update') {
            if (this.initInvoiceType !== null && this.formData.invoice_type !== this.initInvoiceType) {
              // 如果修改了发票类型
              if (this.formData.invoice_type === 0) {
                // 由普票修改为专票，已确认专票金额应加上原金额
                result = this.application_special_amount + this.initAmount
              } else { 
                // 由专票修改为普票，已确认专票金额应减去原金额
                result = this.application_special_amount - this.initAmount
              }
            } else {
              if (this.formData.invoice_type === 0) {
                result = this.application_special_amount + parseFloat(this.formData.invoiced_amount) - this.initAmount
              } else {
                return this.application_special_amount
              }
            }
          } else if (this.dialogStatus === 'action.check') {
            if ( this.initInvoiceType === 0) {
              result = this.application_special_amount - this.initAmount
            } else {
              result = this.application_special_amount
            }
          }
          return parseFloat(result.toFixed(4))
        },
        modify_application_ordinary_amount: function(){
          if (this.formData.invoice_type === null ||
          this.formData.invoice_type === undefined ||
          this.formData.invoice_type === '' ||
          this.formData.invoiced_amount === null ||
          this.formData.invoiced_amount === undefined ||
          this.formData.invoiced_amount === '') {
            return this.application_ordinary_amount
          }
          let result = 0.0
          if (this.dialogStatus === 'action.update') {
            if (this.initInvoiceType !== null && this.formData.invoice_type !== this.initInvoiceType) {
              // 如果修改了发票类型
              if (this.formData.invoice_type === 0) {
                // 由普票修改为专票，已确认普票金额应减去原金额
                result = this.application_ordinary_amount - this.initAmount
              } else {
                // 由专票修改为普票，已确认普票金额应加上原金额
                result = this.application_ordinary_amount + this.initAmount
              }
            } else {
              if (this.formData.invoice_type === 1) {
                result = this.application_ordinary_amount + parseFloat(this.formData.invoiced_amount) - this.initAmount
              } else {
                return this.application_ordinary_amount
              }
            }
          } else if (this.dialogStatus === 'action.check') {
            if ( this.initInvoiceType === 1) {
              result = this.application_ordinary_amount - this.initAmount
            } else {
              result = this.application_ordinary_amount
            }
          }
          return parseFloat(result.toFixed(4))
        },
        modify_unconfirmed_amount: function(){
          let result = 0.0
          result = this.modify_unconfirmed_special_amount + this.modify_unconfirmed_ordinary_amount
          return parseFloat(result.toFixed(4))
        },
        modify_unconfirmed_special_amount: function(){
          let result = 0.0
          result = this.receivable_special_amount - this.modify_confirmed_special_amount
          return parseFloat(result.toFixed(4))
        },
        modify_unconfirmed_ordinary_amount: function(){
          let result = 0.0
          result = this.receivable_ordinary_amount - this.modify_confirmed_ordinary_amount
          return parseFloat(result.toFixed(4))
        },
        modify_unapplication_amount: function(){
          let result = 0.0
          result = this.modify_unapplication_special_amount + this.modify_unapplication_ordinary_amount
          return parseFloat(result.toFixed(4))
        },
        modify_unapplication_special_amount: function(){
          let result = 0.0
          result = this.modify_unconfirmed_special_amount - this.modify_application_special_amount
          return parseFloat(result.toFixed(4))
        },
        modify_unapplication_ordinary_amount: function(){
          let result = 0.0
          result = this.modify_unconfirmed_ordinary_amount - this.modify_application_ordinary_amount
          return parseFloat(result.toFixed(4))
        },
        headers() {
          return {'Authorization': 'Token ' + getToken()}
        },
        vat: function () {
          let tempAmount = 0.0
          if (this.formData.invoiced_amount !== null && this.formData.invoiced_amount !== undefined && this.formData.invoiced_amount !== '') {tempAmount = this.formData.invoiced_amount}
          let result = (parseFloat(tempAmount) / parseFloat(1.06)) * parseFloat(0.06)
          return result.toFixed(4)
        },
        sales: function() {
          let tempAmount = 0.0
          if (this.formData.invoiced_amount !== null && this.formData.invoiced_amount !== undefined && this.formData.invoiced_amount !== '') {tempAmount = this.formData.invoiced_amount}
          let result = (parseFloat(tempAmount) - (parseFloat(tempAmount) / parseFloat(1.06)) * parseFloat(0.06))
          return result.toFixed(4)
        },
      },
      methods: {
        ChangeInvoiceType(val) {
          this.formData.invoiced_amount = 0
          if (val === 0) {
            this.formData.invoiced_amount = this.modify_unapplication_special_amount
          }
          else if (val === 1) {
            this.formData.invoiced_amount = this.modify_unapplication_ordinary_amount
          }
        },
        resetFormData() {
          this.formData = {
            name: '',
            taxpayer_id: '91440101MA5APK8L9P',
            invoice_number: '',
            invoiced_amount: 0,
            invoiced_date: null,
            finance: null,
            remark: '',
            invoice_remark: '',
            invoice_type:null,
            checked: true
          },
          this.formData2 = {
            refuse_reason: '',
            checked: false
          },
          this.isDisabled = false,
          this.initAmount = 0.0
          this.initInvoiceType = null
        },
        handleCheck(id, showDialogSave) {
          this.showDialogSave = showDialogSave
          this.dialogStatus = 'action.check'
          this.isEdit = true
          let login_userid = this.$store.state.user.user
          this.id = id
          this.resetFormData()
          this.formData.taxpayer_id = '91440101MA5APK8L9P'
          fetchInsuranceFinanceReceivableApplication(this.id)
            .then(res => {
              this.formData = Object.assign({}, res)
              this.is_owner = (login_userid == id)
              this.initInvoiceType = this.formData.invoice_type
              this.initAmount = this.formData.invoiced_amount
              this.dialogVisible = true
              this.isDisabled = true
            })
            .catch(error => {
              this.$error_message(error)
            })
        },
        handleUpadte(id, showDialogSave,insurance_finance_receivable_application_list,amount,invoice_title_list) {
          this.showDialogSave = showDialogSave
          this.dialogStatus = 'action.update'
          this.invoice_title_list = invoice_title_list
          this.select_amount = amount
          let account_sum = 0
            insurance_finance_receivable_application_list.forEach(item => {       
              if (item.status_name === "待审核" || item.status_name === "通过") {
                account_sum = account_sum + parseFloat(item.invoiced_amount)
              }
            })
          this.account_sum = account_sum      
          this.isEdit = false
          let login_userid = this.$store.state.user.user
          this.id = id
          this.resetFormData()
  
          fetchInsuranceFinanceReceivableApplication(this.id)
            .then(res => {
              this.formData = Object.assign({}, res)
              this.is_owner = (login_userid == id)
              this.initInvoiceType = this.formData.invoice_type
              this.initAmount = this.formData.invoiced_amount
              this.dialogVisible = true
              this.isDisabled = true
            })
            .catch(error => {
              this.$error_message(error)
            })
        },
        handleSearchInvoiceTitle(value){
          if (value && this.dialogStatus === 'action.update'){
            this.$set(this.formData, 'name', value.invoice_name)
            this.$set(this.formData, 'number', value.invoice_number)
            this.$set(this.formData, 'invoice_title_type', Number(value.invoice_type))
            this.$set(this.formData, 'invoice_blank_name', value.invoice_blank_name)
            this.$set(this.formData, 'invoice_account', value.invoice_account)
            this.$set(this.formData, 'invoice_address', value.invoice_address)
            this.$set(this.formData, 'invoice_mobile', value.invoice_mobile)
          }

        },
        cancelData() {
          this.resetFormData()
          this.$nextTick(() => {
            this.$refs.dataForm.clearValidate()
            this.$refs.dataForm2.clearValidate()
          })
          this.dialogVisible = false
        },
        handleGetSourceDocumentList(invoiceID) {
          fetchSourceDocumentList(invoiceID, 'insurancefinancereceivable')
            .then( resp=>{
              this.source_document_list = resp
            }).catch( err=>{
              this.$error_message(err)
            })
        },
        handlePreviewSourceDocument(file) {
          window.open(file.url, "_blank")
        },
        handleRemoveSourceDocument(file, fileList) {
          this.source_document_list = fileList
          if (this.showDialogSave) {
            deleteSourceDocument(file.id)
              .then( resp=>{
                this.$message.success('发票已被删除')
              }).catch( err=>{
                this.$error_message(err)
              })
          }
        },
        handleChange(file, fileList) {
          this.source_document_list = fileList
        },
        handleExceed() {
          this.$message({ type:'warning', message:'只能上传1张发票'})
        },
        needSubmitWithSourceDocument() {
          // 检查是否有需要上传的文件存在,判断标准为组件upload的上传文件属性中是否存在raw字段
          let needUpload = false
          if (this.$refs.upload.uploadFiles.length > 0){
            for (let f of this.$refs.upload.uploadFiles){
              if ('raw' in f) {
                needUpload = true
                break
              }
            }
            return needUpload
          }
        },
        handleSubmitWithSourceDocument(param) {
          let fd = new FormData()
        //   this.formData.finance = this.finance_id
          fd.set('name', this.formData.name)
          fd.set('invoice_maker', '广东中小船东互助发展中心')
          fd.set('taxpayer_id', '91440101MA5APK8L9P')
          fd.set('invoice_number', this.formData.invoice_number)
          fd.set('invoiced_amount', this.formData.invoiced_amount)
          fd.set('vat', this.vat)
          fd.set('sales', this.sales)
          fd.set('finance', parseInt(this.formData.finance))
          fd.set('remark', this.formData.remark)
          fd.set('invoice_remark', this.formData.invoice_remark)
          fd.set('invoice_type', this.formData.invoice_type)
          fd.set('refuse_reason', this.formData.refuse_reason)
          fd.set('checked', this.formData.checked)
          fd.set('invoice_title_type',this.formData.invoice_title_type)
          fd.set('invoice_default_type',this.formData.invoice_default_type)
          fd.set('number',this.formData.number)
          fd.set('invoice_blank_name',this.formData.invoice_blank_name)
          fd.set('invoice_account',this.formData.invoice_account)
          fd.set('invoice_address',this.formData.invoice_address)
          fd.set('invoice_mobile',this.formData.invoice_mobile)
          fd.set('receive_email',this.formData.receive_email)
          fd.set('receive_name',this.formData.receive_name)
          fd.set('mobile',this.formData.mobile)
          fd.set('region',this.formData.region)
          fd.set('address',this.formData.address)

          let oldDate = new Date(this.formData.invoiced_date).getTime()
          let newDate = new Date(oldDate)
          fd.set('invoiced_date', formatDateTime(newDate))
  
          if (param !== null){
            let fileObj = param.file
            fd.append('file', fileObj)
          }
  
          if (this.dialogStatus === 'action.check') {
            checkInsuranceFinanceReceivableApplication(this.id, fd)
            .then(res => {
              this.$message.success(`新增收入成功, id=${res.id}`)
              this.$nextTick(() => {
                this.dialogVisible = false
                this.resetFormData()
                this.$refs['dataForm'].clearValidate()
                this.$emit('updateList')
              })
            })
            .catch(error => {
              this.$error_message(error)
            })
          } else {
            this.$error_message('无效的操作')
          }
        },
        updateData(){
          // if(this.modify_unconfirmed_amount < this.formData.invoiced_amount) {
          //   this.$message.error("申请金额不能大于可开票金额");
          //   return
          // }
          // if ((this.account_sum + parseInt(this.formData.invoiced_amount)) > (this.receivable_amount - this.no_invoice)){
          //   this.$message.error("当前申请中和已通过的申请金额已经大于可开票金额，请核对！");
          //   return
          // }
          // if ((parseFloat(this.account_sum) - parseFloat(this.select_amount) + parseFloat(this.formData.invoiced_amount)) > (parseFloat(this.receivable_amount) - parseFloat(this.no_invoice))){
          //   this.$message.error("当前申请中和已通过的申请金额已经大于可开票金额，请核对！");
          //   return
          // }
          this.$refs['dataForm'].validate(valid => {
          if (valid) {

          this.update_form.name = this.formData.name
          this.update_form.id = this.id
          this.update_form.invoice_title_type = this.formData.invoice_title_type
          this.update_form.invoiced_amount = this.formData.invoiced_amount
          this.update_form.finance = this.formData.finance
          this.update_form.remark = this.formData.remark
          this.update_form.invoice_remark = this.formData.invoice_remark
          this.update_form.invoice_type = this.formData.invoice_type
          this.update_form.number = this.formData.number
          this.update_form.invoice_blank_name = this.formData.invoice_blank_name
          this.update_form.invoice_account = this.formData.invoice_account
          this.update_form.invoice_address = this.formData.invoice_address
          this.update_form.invoice_mobile = this.formData.invoice_mobile

          updateInsuranceFinanceApplicationReceivable(this.update_form).then(res => {
                this.$message.success('修改申请成功')  
                this.dialogVisible = false    
                this.$emit('updateList')    
                this.update_form = {}    
                })
                .catch(error => {
                this.$error_message(error)
                })
              }})
        },

        saveData(checked){
            if (checked) {
                this.$set(this.formData, 'checked', checked)
                this.$refs['dataForm'].validate(valid => {
                if (valid) {
                if (this.needSubmitWithSourceDocument()) {
                    this.$refs.upload.submit()
                } else {
                    this.handleSubmitWithSourceDocument(null)
                }
                }
            })
            } else {
                this.$set(this.formData2, 'checked', checked)
                this.$refs['dataForm2'].validate(valid => {
                    if (valid) {
                        let fd = {}
                        checkInsuranceFinanceReceivableApplication(this.id, this.formData2).then(res => {
                            this.$message.success(`拒绝申请成功, id=${this.id}`)
                            this.$nextTick(() => {
                                this.dialogVisible = false
                                this.resetFormData()
                                this.$refs['dataForm'].clearValidate()
                                this.$refs['dataForm2'].clearValidate()
                                this.$emit('updateList')
                            })
                            })
                            .catch(error => {
                            this.$error_message(error)
                            })
                    }
                })
            }
            
        }
      },
      created() {
      }
    }
  </script>
  